var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuejs-loadmore-wrap"},[_c('div',{ref:"track",staticClass:"vuejs-refresh-track",style:({
    transform: _vm.distance ? `translate3d(0, ${_vm.distance}px, 0)` : '',
    webkitTransform: _vm.distance ? `translate3d(0, ${_vm.distance}px, 0)` : '',
    transitionDuration: `${_vm.duration}ms`,
  })},[_c('div',{staticClass:"vuejs-refresh-head",style:(_vm.headStyle)},[_c('img',{staticClass:"icon",attrs:{"src":_vm.image_src}})]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }